const PP_ARROW_ICON_COMMON = 'https://cdn-gpd.x-plarium.com/browser/content/landings/info_Icons/arrows/pp.png';

export function getCurrentArrowIconUrl(widgetDownloadMessage: Edge.WidgetDownloadMessage, appId: number): string {
  const arrowIcons = widgetDownloadMessage.repeaters.arrowIcons;

  if (!arrowIcons || !arrowIcons.length) {
    return PP_ARROW_ICON_COMMON;
  }

  const currentArrowIconItem = arrowIcons.find((icon) => icon.strings.gameId === appId.toString());

  return currentArrowIconItem ? currentArrowIconItem.images.arrowIcon.src : PP_ARROW_ICON_COMMON;
}
